import { Control, FieldErrors, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import React from 'react'
import { t } from 'ttag'

import { FormData } from '../../ChallengeAdmin'
import { CompanyId, CustomType, GoalId, GoalWithProgress } from '../../../../services/api.types'
import Typography from '@material-ui/core/Typography'
import { FormGroup, ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { getPeriodWithDays } from '../../../ChallengeInfo/ChallengeInfo'
import YumFormSwitch from '../../../../components/YumFormSwitch/YumFormSwitch'
import { convertUTCToLocalDate } from '../../../../common/helpers/date'
import { YumActivityIcon } from '../../../../components/YumActivityIcon/YumActivityIcon'
import YumMediumTitle from '../../../../components/YumMediumTitle/YumMediumTitle'
import { CustomTypeCategory } from '../../../../services/CustomTypes'
import dayjs from '../../../../dayjsConfig'

interface ChallengeTotalPointsIncludesProps {
  control: Control<FormData, any>
  watch: UseFormWatch<FormData>
  register: UseFormRegister<FormData>
  setValue: UseFormSetValue<FormData>
  errors: FieldErrors<FormData>
  goals: GoalWithProgress[]
  companyId: CompanyId
}

export function filterTotalChallengesThatCover(
  companyId: CompanyId,
  challenges: GoalWithProgress[],
  startDate?: Date,
  endDate?: Date,
): GoalWithProgress[] {
  if (!startDate || !endDate) return []
  const startMs = startDate.getTime()
  const endMs = endDate.getTime()
  // console.log('endMs', endMs)
  return challenges
    .filter((challenge) => {
      /*if (challenge.companyId === companyId && challenge.customType === CustomType.TOTAL_POINTS)
        console.log(
          convertUTCToLocalDate(new Date(challenge.startDate)),
          convertUTCToLocalDate(new Date(challenge.endDate)),
          dayjs(convertUTCToLocalDate(new Date(challenge.endDate))).endOf('day').valueOf(),
        )*/
      return (
        challenge.companyId === companyId &&
        challenge.customType === CustomType.TOTAL_POINTS &&
        convertUTCToLocalDate(new Date(challenge.startDate)).getTime() <= startMs &&
        dayjs(convertUTCToLocalDate(new Date(challenge.endDate)))
          .endOf('day')
          .valueOf() >= endMs
      )
    })
    .sort((a, b) => a.startDate - b.startDate)
}

export default function ChallengeTotalPointsIncludes(props: ChallengeTotalPointsIncludesProps) {
  const { control, setValue, watch, goals, companyId } = props

  const includeInTotalPointsChallenges = watch('includeInTotalPointsChallenges')
  const dateRange = watch('dateRange')
  const relevantTotalPointChallenges = filterTotalChallengesThatCover(companyId, goals, dateRange[0], dateRange[1])

  return (
    <>
      {relevantTotalPointChallenges.length > 0 && (
        <>
          <YumMediumTitle>{t`Include in challenges`}</YumMediumTitle>

          <FormGroup>
            {relevantTotalPointChallenges.map((challenge, i) => (
              <ListItem
                key={i}
                role={undefined}
                dense
                button
                onClick={() =>
                  setValue(
                    `includeInTotalPointsChallenges.${challenge.id}`,
                    !includeInTotalPointsChallenges[challenge.id],
                  )
                }
              >
                <ListItemIcon>
                  <YumActivityIcon category={CustomTypeCategory.POINTS} color={'darkBlue'} isInactive={true} />
                </ListItemIcon>
                <ListItemText primary={challenge.title} secondary={getPeriodWithDays(challenge)} />
                <ListItemIcon>
                  <YumFormSwitch control={control} name={`includeInTotalPointsChallenges.${challenge.id}`} />
                </ListItemIcon>
              </ListItem>
            ))}
          </FormGroup>
        </>
      )}
    </>
  )
}
